<i18n>
{
  "ru": {
    "signIn": "Вход",
    "done": "Войти",
    "close": "Закрыть"
  },
  "uk": {
    "signIn": "Вхід",
    "done": "Увійти",
    "close": "Закрити"
  }
}
</i18n>

<template>
  <div>
    <a class="nav-link" @click.prevent="showModal" href="#">{{
      $t("signIn")
    }}</a>
    <b-modal
      class="as-modal"
      ref="modal"
      lazy
      hide-footer
      static
      no-close-on-backdrop
      :title="$t('signIn')"
    >
      <div class="d-block">
        <b-form class="as-form" v-on:submit.prevent="sendAuth">
          <b-form-group label="Email:" label-for="email">
            <b-form-input
              type="email"
              name="email"
              v-model.trim="form.email"
            ></b-form-input>
          </b-form-group>
          <b-form-group label="Пароль:" label-for="password">
            <b-form-input
              type="password"
              name="password"
              v-model.trim="form.password"
            ></b-form-input>
          </b-form-group>
          <b-form-group class="text-right">
            <span class="text-danger" v-if="$store.state.session.err">{{
              $store.state.session.err
            }}</span>
            <b-btn class="btn btn-default" type="button" @click="hideModal">{{
              $t("close")
            }}</b-btn>
            <b-btn class="btn btn-primary btn-auth" type="submit">{{
              $t("done")
            }}</b-btn>
          </b-form-group>
        </b-form>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        email: "",
        password: ""
      }
    };
  },
  methods: {
    showModal() {
      this.$refs.modal.show();
    },
    hideModal() {
      this.$store.state.session.err = null;
      this.$refs.modal.hide();
    },
    sendAuth() {
      this.$store.state.session.err = null;
      this.$auth.signIn(this.$store, this.form.email, this.form.password);
    }
  }
};
</script>

<style scoped src="@/assets/css/modal.css"></style>
